import styled from 'styled-components'
import { InputStyle, InputAttributes } from './input'
import { colors } from '../../../styles/theme'

const Select = styled.select`
  ${InputStyle}
  appearance: none;
  text-indent: 2px;
  background: ${({ variant }: InputAttributes) =>
      variant === 'outlined' ? 'transparent' : colors.neutral100}
    url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M2 7L9.5 14.5L17 7' stroke='currentColor' stroke-linecap='round'/%3E%3C/svg%3E%0A")
    no-repeat right 0.75rem center;
`

export default Select
